import React, { useState } from "react";
import { FiAlertCircle } from "react-icons/fi";
import "../auth.css";
import { executeLogin } from "../workflows/loginWorkflow";

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmedUser = username.trim();
    const trimmedPass = password.trim();

    if (!trimmedUser || !trimmedPass) {
      setError("Please enter both username and password.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const result = await executeLogin(trimmedUser, trimmedPass);

      // Notify the host — pass must_reset_password flag and user_id
      onLogin(trimmedUser, {
        mustResetPassword: result.mustResetPassword,
        accessToken: result.accessToken,
        userId: result.userId,
      });
    } catch (err) {
      setError(err.message || "Authentication failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <section className="login-left-panel" aria-hidden="true">
        <div className="login-brand">
          <span className="login-brand-arrow">&gt;</span>
          <span className="login-brand-text">Accenture</span>
        </div>
        <h1 className="login-title">ATC Gen AI Store</h1>
        <p className="login-subtitle">
          Leverage AI-powered assistants to optimize your productivity and transform how you work.
        </p>
      </section>

      <section className="login-right-panel">
        <div className="login-card">
          <h2 className="login-card-title">Welcome</h2>
          <p className="login-card-text">
            Sign in with your credentials to continue.
          </p>

          <form className="login-form" onSubmit={handleSubmit}>
            <label htmlFor="username" className="login-label">
              Login ID
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              className="login-input"
              placeholder="Enter your login ID (e.g. johki)"
              autoComplete="username"
              required
              disabled={loading}
            />

            <label htmlFor="password" className="login-label">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="login-input"
              placeholder="Enter your password"
              autoComplete="current-password"
              required
              disabled={loading}
            />

            {error && (
              <p className="login-error">
                <FiAlertCircle className="login-error-icon" />
                <span>{error}</span>
              </p>
            )}

            <button
              type="submit"
              className="login-submit-btn"
              disabled={loading}
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default LoginPage;
